import { Navigate } from "react-router-dom";

import { useAuth } from "contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
    const { status } = useAuth();

    if (status === "checking") {
        return null;
    }

    if (status !== "authenticated") {
        return <Navigate to="/auth/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
